import { createSelector } from 'reselect'
import { getContextName } from 'Helper/routeHelpers'

export const contextSelector = createSelector(
  state => state.router.location.pathname,
  getContextName
)
